<template lang="pug">
  LayoutDefault
    .fixedlayout
      .fixedlayout--header
        .card.fixedlayout--stockselection
          .container-fluid
            .row.no-gutters.align-items-center
              .col-sm-auto
                .mar_r--10
                  span.text--size_12.text__uppercase 
                    | Filter by counter 
                  span.text--size_12.mar_l--10.text--color_grey.hidden_xsm
                    font-awesome-icon(icon="angle-right")
              .col-sm.mar_t--10-xsm
                SelectSingleStock(@stockSelected="UPDATE_STOCK_SELECTION", :defaultCounterCode="stockCode")

      .fixedlayout--body
        .card.fixedlayout--iframe
          iframe#iframeFundamental(:src="iframeUrl", frameborder="0")
</template>



<script>
import { mapState, mapActions } from 'vuex';

import setStockCode from '../../mixins/setStockCodes';
import requestHandlers from '../../mixins/requestHandlers';
import SelectSingleStock from '../../components/SelectSingleStock';

export default {
  name: 'stocksFundamentals',
  mixins: [setStockCode, requestHandlers],
  components: {
    SelectSingleStock
  },

  data() {
    return {
      resizeInterval: null,
      isDevelopment: process.env.VUE_APP_ENVIRONMENT === 'development',
    }
  },

  computed: {
    ...mapState('stock', [
      'allStocks'
    ]),
    ...mapState('auth', [
      'msToken'
    ]),
    
    finalStockCode() {
      let _stockCode = '';

      // Overrides stock code to be from query string from route
      if(this.stockCode) {
        _stockCode = this.stockCode;

        if (_stockCode.length === 10) {
          let stock = this.allStocks.find(stock => stock.attributes.shareClassId === _stockCode);

          if (stock) {
            this.$router.push({query: { stockCode: stock.id }})
          }
        }

        // Find and set _stockCode with MorningStar shareClassId
        let stock = this.allStocks.find(stock => stock.id === _stockCode);

        if (stock) {
          _stockCode = stock.attributes.shareClassId;
        }
      }

      return _stockCode;
    },

    iframeUrl() {
      let _url = '';

      if(this.isDevelopment) {
        _url = 'http://localhost:3100/iframes/fundamentals.html?';
      } else {
        _url = 'https://einvest.affinhwang.com//ms-iframe-fundamental?';
      }

      let allQueries = [];

      if(this.msToken) {
        allQueries.push(`token=${this.msToken}`);
      }

      if(this.finalStockCode) {
        allQueries.push(`ticker=${this.finalStockCode}`);
      }

      if(allQueries.length) {
        _url += `${allQueries.join('&')}`
      }

      return _url;
    }
  },


  methods: {
    ...mapActions('stock', [
      'setCurrentStock' 
    ]),
    UPDATE_STOCK_SELECTION(stockCode) {
      this.setCurrentStock(stockCode)
      this.$router.push({query: { stockCode: stockCode}})
    },
  },
}

</script>




<style lang="scss">
  #iframeFundamental {
    width: 100%; 
    height: 100%;
  }

  /*
  #iframeFundamental {
    width: 100%; 
    min-height: 450px;
    overflow: hidden !important;    
  }

  #iframeFundamental::-webkit-scrollbar {  
    display: none !important;
  } 
  */ 	
</style>
